import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import RollbackButton from '../../../_common/elements/RollbackButton';

import css from './StudentDetails.module.css';

import toShort from '../../../../../services/utils/dateParser';
import * as studentServices from '../../../../../services/studentServices';
import * as enrollServices from '../../../../../services/enrollServices';
import ViewCertificateButton from '../../../_common/elements/ViewCertificateButton';
import SDGeneral from './SDGeneral';
import ModalForm from '../../../_common/ModalForm';
import AddNewStudent from '../overview/AddNewStudent';

function StudentDetails() {
    const { studentId } = useParams();
    const [studentDetails, setStudentDetails] = useState([{ studentId }]);
    const [showModal, setShowModal] = useState(false);
    const [render, setRender] = useState(0);

    useEffect(() => {
        studentServices
            .getById(studentId)
            .then((result) => {
                // console.log(result.data);
                setStudentDetails((state) => result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [studentId, render, showModal]);

    const onConfirmRollback = (enrollId) => {
        console.log(enrollId);
        enrollServices
            .del({ _id: enrollId })
            .then((result) => {
                setStudentDetails(studentDetails.filter((x) => x.enrollId !== enrollId));
                console.log(result);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    // const showCertificate = (certificateref) => {
    //     console.log(certificateref);
    // };

    // console.log(studentDetails);

    const toggleModal = () => setShowModal(!showModal);

    const onAdd = (data) => {
        setRender((s) => ++s);
    };

    

    return (
        <div>
            <h1 className={css.h1}>{`(${studentDetails[0].studentNo}) ${studentDetails[0].studentFirstName} ${
                studentDetails[0].studentMidName === 'null' ? ' ' : studentDetails[0].studentMidName + ' '
            }${studentDetails[0].studentLastName}`}</h1>
            <SDGeneral student={studentDetails[0]} toggleModal={toggleModal} />
            <ModalForm showModal={showModal}>
                <AddNewStudent studentData={studentDetails[0]} onAdd={onAdd} toggleModal={toggleModal} func={'edit'} />
            </ModalForm>
            <div className={css.course}>
                <h2 className={css.h2}>Courses</h2>
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th className={`${css.th} ${css.center}`}>Request</th>
                            <th className={css.th}>Course</th>
                            <th className={`${css.th} ${css.center}`}>Start</th>
                            <th className={`${css.th} ${css.center}`}>End</th>
                            <th className={`${css.th} ${css.center}`}>Cat</th>
                            <th className={`${css.th} ${css.center}`}>Att?</th>
                            <th className={`${css.th} ${css.center}`}>Exams?</th>
                            <th className={css.th}>Customer</th>
                            <th className={`${css.th} ${css.center}`}></th>
                        </tr>
                    </thead>
                    <tbody className={css.tbody}>
                        {studentDetails.map((x) =>
                            studentDetails[0].requestId ? (
                                <tr key={x.requestId} id={x.requestId}>
                                    <td className={css.center}>{x.requestId}</td>
                                    <td>
                                        <Link className={css.link} to={`/course/details/${x.courseId}`}>
                                            {x.courseTitle}
                                        </Link>
                                    </td>
                                    <td className={css.center}>{toShort(x.courseStart)}</td>
                                    <td className={css.center}>{toShort(x.courseEnd)}</td>
                                    <td className={css.center}>{x.enrollId && x.licenseCategoryTitle}</td>
                                    <td className={`${css.symbol} ${css.center}`} style={x.isAtt ? { color: 'green' } : { color: 'red' }}>
                                        {x.enrollId && (x.isAtt ? '☑' : '☒')}
                                    </td>
                                    <td className={`${css.symbol} ${css.center}`} style={x.isPass ? { color: 'green' } : { color: 'red' }}>
                                        {x.enrollId && (x.isPass ? '☑' : '☒')}
                                    </td>

                                    <td>{x.customerName}</td>
                                    <td className={css.center}>
                                        {!x.courseTitle || Number(x.courseStatusId) === 3 ? (
                                            <></>
                                        ) : (
                                            <RollbackButton enrollId={x.enrollId} onConfirm={onConfirmRollback} />
                                        )}
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={7} style={{ textAlign: 'center' }}>
                                        No matching records found.
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
                {/* {studentDetails.map((x) => (
                    <p key={x.enrollId}>
                        {x.courseTitle} from {toShort(x.courseStart)} to {toShort(x.courseEnd)} as{' '}
                        {x.licenseCategoryTitle}, {x.customerName}
                    </p>
                ))} */}
            </div>
            <div className={css.course}>
                <h2 className={css.h2}>Certificates</h2>
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th className={`${css.th} ${css.center}`}>Request</th>
                            <th className={`${css.th} ${css.center}`}>Ref</th>
                            <th className={css.th}>Certificate</th>
                            <th className={`${css.th} ${css.center}`}>Date</th>
                            <th className={`${css.th} ${css.center}`}>Status</th>
                            <th className={`${css.th} ${css.center}`}></th>
                        </tr>
                    </thead>
                    <tbody className={css.tbody}>
                        {studentDetails.map((x) =>
                            // studentDetails[0].requestId ? (
                            x.requestId === x.certificateRequestId ? (
                                <tr key={x.requestId} id={x.requestId}>
                                    <td className={css.center}>{x.requestId}</td>
                                    <td className={css.center}>{x.certificateRef}</td>
                                    <td>{x.courseTitle || 'No certificate'}</td>
                                    <td className={css.center}>{toShort(x.certificateIssueDate)}</td>
                                    <td className={css.center}>{x.certificateStatusTitle}</td>
                                    {/* <td>{!x.certificateLink ? <></> : <button onClick={() => showCertificate(x.certificateRef)}>View</button>}</td> */}
                                    <td className={css.center}>
                                        <ViewCertificateButton certificateLink={x.certificateLink} />
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: 'center' }}>
                                        No matching records found.
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default StudentDetails;
